<template>
  <page>
    <ZuiHeader />
    <SubPageTemplate page-title="精美图库" :page-nav="false" :pid="pid" type="picture"></SubPageTemplate>
    <ZuiFooter />
  </page>
</template>
<script>
import SubPageTemplate from "~/components/template/SubPageTemplate.vue";
export default {
  components: {
    SubPageTemplate
  },
  data() {
    return {
      pid: null,
      visible: false,
      src: null
    }
  },
  created() {
    this.pid = this.$route.query.id;
  }
}
</script>



// WEBPACK FOOTER //
// src/views/link/picture.vue